function QuantityControl({ value, onDecrease, onIncrease, decreaseLabel, increaseLabel }) {
  return (
    <>
      <button className="qtyBtn" type="button" aria-label={decreaseLabel} onClick={onDecrease}>
        −
      </button>
      <div className="qty">{value}</div>
      <button
        className="qtyBtn primary"
        type="button"
        aria-label={increaseLabel}
        onClick={onIncrease}
      >
        +
      </button>
    </>
  );
}

export default QuantityControl;
